import React from "react"
import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, Dropdown, theme } from "antd"
import { Header } from "antd/es/layout/layout"
import { UserOutlined } from "@ant-design/icons"

import { authStore } from "@src/app/authStore"
import { paths } from "@src/app/paths"
import css from "./index.module.css"

export type Props = {
  children: React.ReactElement
}
export const EmptyLayoutWithLogout = observer(({ children }: Props) => {
  const { token } = theme.useToken()

  const navigate = useNavigate()

  const { logout, merchant } = authStore

  return (
    <>
      <Header
        style={{
          alignItems: "center",
          background: token.colorBgLayout,
          display: "flex",
          justifyContent: "flex-end",
          textAlign: "right",
        }}
      >
        <div className={css.buttonsWrapper}>
          <Dropdown
            menu={{
              items: [
                {
                  key: "exit",
                  label: (
                    <a
                      onClick={() => logout().then(() => navigate(paths.auth))}
                    >
                      Exit
                    </a>
                  ),
                },
              ],
            }}
          >
            <Button
              icon={<UserOutlined />}
              id="GENERATED_ID_STATUSCONFIRMATION_BUTTON_VOID_1"
              size="large"
            >
              {merchant?.email}
            </Button>
          </Dropdown>
        </div>
      </Header>

      {children}
    </>
  )
})
